import { Injectable } from '@angular/core';

/**
 * Browser-independent equivalent of Ctrl+Shift+R. Pages cannot trigger a real hard reload
 * (location.reload(true) is ignored outside old Firefox), and the Angular service worker would
 * serve the old bundle anyway. So: drop the service worker and its caches, refetch the page
 * bypassing the HTTP cache, then reload. Works the same on desktop, iOS, Android and in the app.
 */
@Injectable({
  providedIn: 'root'
})
export class ForceRefreshService {

  async forceRefresh(win: any = window): Promise<void> {
    try {
      const registrations = await win.navigator.serviceWorker?.getRegistrations() ?? [];
      await Promise.all(registrations.map((r: ServiceWorkerRegistration) => r.unregister()));
    } catch { /* reload regardless */ }

    try {
      const keys: string[] = await win.caches?.keys() ?? [];
      await Promise.all(keys.map(key => win.caches.delete(key)));
    } catch { /* reload regardless */ }

    try {
      await win.fetch(win.location.href, { cache: 'reload' });
    } catch { /* reload regardless */ }

    win.location.reload();
  }
}
